import defaultApi from './defaultApi';
import store from '@/store';
import { sendRequest } from './common/commonApi';
const logApi = {
  log: {
    prefix: process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings/log',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {
      '/v1/console/dashboards/accumulate-per-product': {
        get: { desc: '안돼!!', test: true }
      }
    },
    SAMPLE: {},

    // 로그 상품 유형 조회
    getLogProductTypes() {
      if (store.getters.existLogProductType()) {
        return Promise.resolve(store.getters.getLogProductTypes());
      }

      return new Promise((resolve) => {
        let param = {};
        this.get('/v1/console/logs/product-types', param).then((data) => {
          let _codes = [];
          if (data) {
            for (let i = 0; i < data.contents.length; i++) {
              let _row = data.contents[i];
              _codes.push({ text: _row.productTypeName, value: _row.productTypeCode, ..._row });
            }
          }

          store.dispatch('setLogProductTypes', _codes);
          resolve(_codes);
        });
      });
    },

    // 로그 현황 목록 조회
    getProductLogs(params, handledAuthError = false) {
      return sendRequest(
        this.post.bind(this),
        `/v1/console/products/logs`,
        {
          params,
          handledAuthError,
          productTypeCode: params.productTypeCode
        },
        true
      );
    },

    // 지표 설정 현황 목록 조회
    getLogMetrics(params, handledAuthError = false) {
      return sendRequest(
        this.post.bind(this),
        `/v1/console/log-metrics/search`,
        {
          params,
          handledAuthError,
          productTypeCode: params.productTypeCode
        },
        true
      );
    },

    // 지표 삭제
    deleteLogMetric(params) {
      return new Promise((resolve, reject) => {
        this.delete(`/v1/console/log-metrics/${params.metricSq}`, {}, false, false, {
          headers: { 'X-ResourceType': params.productTypeCode }
        })
          .then((data) => {
            if (Object.keys(data).length > 0) {
              return resolve(data);
            }
          })
          .catch((error) => reject(error));
      });
    },

    // 로그 검색 조건 필드 목록 조회
    getLogFields(params, productTypeCode, loadingBar = false) {
      return new Promise((resolve, reject) => {
        this.post(`/v1/console/logs/fields`, params, loadingBar, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 로그 발생량 조회(차트)
    getLogDataUsage(params, productTypeCode, loadingBar, handledAuthError = false) {
      return sendRequest(this.post.bind(this), `/v1/console/logs/log-data/usage`, {
        params,
        productTypeCode,
        loadingBar,
        handledAuthError
      });
    },

    // 발생 로그 메시지 목록 조회
    getLogData(params, productTypeCode, loadingBar, handledAuthError = false) {
      return sendRequest(this.post.bind(this), '/v1/console/logs/log-data', {
        params,
        productTypeCode,
        loadingBar,
        handledAuthError
      });
    },

    // 지표 저장
    addLogMetrics(params, productTypeCode) {
      return new Promise((resolve, reject) => {
        this.post(`/v1/console/log-metrics`, params, true, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 지표 수정
    updateLogMetrics(params, metricSq, productTypeCode) {
      return new Promise((resolve, reject) => {
        this.put(`/v1/console/log-metrics/${metricSq}`, params, true, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 발생 로그 메시지 다운로드
    downloadLogData(params, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.post(
          `/v1/console/logs/log-data/download`,
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode },
            responseType: 'blob'
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    // 실행 이력 조회
    getQueryHistory(params, productTypeCode, handledAuthError = false) {
      return sendRequest(this.get.bind(this), '/v1/console/logs/query-histories', {
        params,
        productTypeCode,
        handledAuthError
      });
    },

    // 모니터링 대상의 로그 목록 조회
    getLogs(params, productTypeCode, handledAuthError = false) {
      return sendRequest(
        this.get.bind(this),
        `/v1/console/logs`,
        {
          params,
          productTypeCode,
          handledAuthError
        },
        true
      );
    },

    // 수집 로그 목록 조회
    getLogAgent(params, productTypeCode, handledAuthError = false) {
      return sendRequest(this.get.bind(this), `/v1/console/logs/agent`, {
        params,
        productTypeCode,
        handledAuthError
      });
    },

    // 로그 설정 사용 여부 조회
    getLogEditable(params, productTypeCode) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/products/log/editable`, params, true, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 누적 로그 발생량
    getAccumulateTotal(params) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/log-data/accumulate-total`, params, true, false, {})
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 최근 7일 로그 수집량
    getAccumulatePerDay(params) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/log-data/accumulate-per-day`, params, true, false, {})
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 상품별 로그 발생 비율
    getAccumulatePerProduct(params) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/log-data/accumulate-per-product`, params, true, false, {})
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    // 로그 수집 top 10
    getProductListUsage(params) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/log-data/product-log-usage`, params, true, false, {})
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },
    getProductAgentLog(params, handledAuthError = false) {
      let url = `/v1/console/products/agentLogs?productSq=${params.productSq}`;

      if (params.isLogSearch) {
        url += `&isLogSearch=${params.isLogSearch}`;
      }

      return new Promise((resolve, reject) => {
        this.get(
          url,
          {},
          true,
          false,
          {
            headers: { 'X-ResourceType': params.productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },
    getLogProductType() {
      return new Promise((resolve) => {
        let param = {};
        this.get('/v1/console/logs/product-types', param, true, false)
          .then((res) => {
            let data = [];
            if (res.contents && res.contents.length) {
              data = res.contents.map((item) => {
                return {
                  ...item,
                  text: item.productTypeName,
                  key: item.productTypeCode
                };
              });
            }
            resolve(data);
          })
          .catch((error) => reject(error));
      });
    }
  }
};
logApi.log = Object.assign(logApi.log, defaultApi);
export default logApi;
